import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-tasks" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Progresso ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" : ")
const _hoisted_4 = {
  key: 0,
  class: "p-error"
}
const _hoisted_5 = {
  key: 1,
  class: "p-error"
}
const _hoisted_6 = {
  key: 2,
  class: "p-error"
}
const _hoisted_7 = {
  key: 1,
  class: "p-success"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Timeline = _resolveComponent("Timeline")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { class: "p-mb-2" }, {
    title: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      ([300, 500].includes(_ctx.order.status))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_3,
            (_ctx.order.status === 300)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Annullato"))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, "Rifiutato")),
            (_ctx.isRefunded)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "/ Rimborso emesso"))
              : _createCommentVNode("", true)
          ], 64))
        : (_ctx.order.payment_status === 20)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, "(PAGATO)"))
          : _createCommentVNode("", true)
    ]),
    content: _withCtx(() => [
      _createVNode(_component_Timeline, {
        class: "order-timeline",
        value: _ctx.timelineData,
        layout: _ctx.layout,
        align: _ctx.align
      }, {
        marker: _withCtx(({ item: {icon } }) => [
          _createElementVNode("i", {
            class: _normalizeClass(icon)
          }, null, 2)
        ]),
        content: _withCtx(({ item }) => [
          _createElementVNode("span", {
            class: _normalizeClass({ 'current-status': item.isActive })
          }, _toDisplayString(item.label), 3)
        ]),
        _: 1
      }, 8, ["value", "layout", "align"])
    ]),
    _: 1
  }))
}